import { render, staticRenderFns } from "./ServiceStatis.vue?vue&type=template&id=525c9ad6&"
import script from "./ServiceStatis.vue?vue&type=script&lang=js&"
export * from "./ServiceStatis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports